<p-tabs
  [value]="activeValue"
  (valueChange)="onTabValueChange($event)"
  [ngClass]="styleClass ? styleClass : ''"
  class="mobile-css"
>
  <p-tablist>
    @for (tab of tabs; track tab.label) {
      <p-tab [value]="tab.label" [disabled]="tab.disabled ?? false">{{ tab.label }}</p-tab>
    }
  </p-tablist>
</p-tabs>

<div class="mobile-tab-menu">
  <button mat-raised-button (click)="menuCmp.toggle($event)" class="mobile-menu-button">
    {{ activeTab ? activeTab.label : '' }}
    <mat-icon svgIcon="arrow_drop_down"></mat-icon>
  </button>
  <p-menu #menu [popup]="true" appendTo="body" [model]="tabs" class="mobile-menu-button"></p-menu>
</div>
